import { Link } from 'react-router-dom';
import InlineCTA from './InlineCTA';

const faqList = [
  {
    question: '電競投注合法嗎？',
    answer: '台灣運彩目前尚未開放電競投注。境外網站提供的電競盤口在台灣不受法律保障，玩家仍有刑法第 266 條賭博罪風險，出金糾紛也難以求償。全球有越來越多國家和地區已將電競投注納入合法監管範圍。',
  },
  {
    question: '電競投注會被假賽影響嗎？',
    answer: '假賽（Match Fixing）是電競投注面臨的最大風險之一。雖然各大賽事主辦方和遊戲開發商都有反假賽機制，但中低階聯賽仍偶有假賽事件。降低風險的方法：只投注頂級賽事（如 Worlds、Major）、避免投注低階聯賽和線上資格賽、以及關注賠率是否有異常波動。',
  },
  {
    question: 'LOL 和 CS2 哪個比較好分析？',
    answer: 'CS2 相對更容易入門分析。原因是 CS2 的地圖池固定、戰術體系相對穩定，且歷史數據的參考價值較高。LOL 因為每個版本都會調整英雄和裝備數值，遊戲環境持續變化，需要投注者緊密追蹤版本更新。但如果你本身就是 LOL 玩家，對版本變化有直覺理解，LOL 的分析也並不困難。',
  },
  {
    question: '電競投注的賠率準確嗎？',
    answer: '頂級賽事（Worlds、Major 等）的賠率通常很準確，因為市場交易量大、資訊透明度高。但在較小的賽事或資格賽中，博彩公司的分析師可能不如核心電競玩家了解遊戲和選手狀態，這時候的賠率可能存在價值空間。不過這也意味著這些小賽事的風險（包括假賽風險）更高。',
  },
  {
    question: '版本更新對電競投注有什麼影響？',
    answer: '影響非常大，特別是 LOL 和 Valorant。每次大版本更新都可能改變遊戲的強勢角色和策略方向，擅長舊版本打法的隊伍可能在新版本中表現失常。投注時需要關注：① 大賽使用的是哪個遊戲版本 ② 該版本與上個版本的差異有多大 ③ 各隊伍對新版本的適應速度。通常版本更新後的前幾場比賽冷門機率較高。',
  },
];

export default function EsportsBettingGuide() {

  return (
    <div>
<article style={{ maxWidth: 800, margin: '0 auto', lineHeight: 1.8, color: '#e0e0e0' }}>
        <h1>電競投注教學 2026｜LOL、CS2 賽事投注策略入門</h1>

        {/* ========== 導讀 ========== */}
        <p>
          電子競技已經從小眾的遊戲圈文化，成長為全球數十億美元產值的產業。隨著電競觀眾人數持續增長，電競投注市場也迅速擴大——根據產業估計，2026 年全球電競投注市場規模已超過 200 億美元。LOL Worlds、CS2 Major、Valorant Champions 等頂級賽事的投注量甚至可以和傳統運動的大型賽事相媲美。
        </p>
        <p>
          對於熟悉電競遊戲的玩家來說，電競投注有一個天然的優勢——你對遊戲機制、選手實力和戰術體系的了解，可能比博彩公司的分析師更深入。但電競投注也有其獨特的風險：假賽問題、版本更新帶來的不確定性、以及選手狀態的波動性。
        </p>
        <p>
          本文將全面介紹電競投注的基礎知識，從主流賽事和投注類型開始，再深入 LOL 和 CS2 的投注分析方法，最後討論電競投注的風險管理。不論你是想從觀看電競比賽進階到投注的新手，還是想提升分析能力的老手，這篇指南都能提供實用的框架。
        </p>
        <p>
          <strong>重要提醒：</strong>電競投注屬於娛樂消遣，不是穩定獲利的方式。請在自己能承受的範圍內理性投注。如有賭博成癮問題，請撥打求助專線 <strong>衛福部安心專線 1925</strong>（全年無休），或前往<a href="https://165.npa.gov.tw" target="_blank" rel="noopener noreferrer" style={{ color: '#93c5fd' }}>165 反詐騙諮詢專線</a>尋求協助。
        </p>

        {/* ========== 目錄 ========== */}
        <nav aria-label="文章目錄" style={{ background: 'rgba(212,175,55,0.06)', border: '1px solid rgba(212,175,55,0.15)', borderRadius: 12, padding: '16px 20px', margin: '24px 0' }}>
          <p style={{ fontWeight: 700, marginBottom: 8, color: '#D4AF37' }}>本文目錄</p>
          <ol style={{ margin: 0, paddingLeft: 20, lineHeight: 2 }}>
            <li><a href="#market">電競投注市場概覽</a></li>
            <li><a href="#events">主流電競賽事介紹</a></li>
            <li><a href="#bet-types">電競投注類型</a></li>
            <li><a href="#lol">LOL 投注入門</a></li>
            <li><a href="#cs2">CS2 投注入門</a></li>
            <li><a href="#risks">電競投注風險管理</a></li>
            <li><a href="#faq">FAQ 常見問題</a></li>
          </ol>
        </nav>

        {/* ==================== 第 1 節 ==================== */}
        <h2 id="market">一、電競投注市場概覽</h2>
        <p>
          電競投注的成長速度遠超傳統運動博彩。這個市場的核心玩家群體是 18-35 歲的年輕世代——他們對遊戲有深入了解、習慣線上消費、而且對數據分析有天然的親近感。
        </p>

        <h3>電競投注 vs 傳統運動投注</h3>
        <table>
          <thead>
            <tr><th>比較項目</th><th>電競投注</th><th>傳統運動投注</th></tr>
          </thead>
          <tbody>
            <tr><td>比賽頻率</td><td>極高，幾乎每天有賽事</td><td>高，但有明顯淡旺季</td></tr>
            <tr><td>資訊取得</td><td>網路即時、社群活躍</td><td>媒體報導為主</td></tr>
            <tr><td>版本變化</td><td>遊戲更新頻繁，環境持續改變</td><td>規則穩定</td></tr>
            <tr><td>假賽風險</td><td>中低階賽事風險較高</td><td>較低（監管成熟）</td></tr>
            <tr><td>盤口深度</td><td>頂級賽事豐富，小賽事較少</td><td>大小賽事都有完整盤口</td></tr>
            <tr><td>選手資訊</td><td>社群曝光高、狀態可追蹤</td><td>需透過專業管道取得</td></tr>
          </tbody>
        </table>

        <h3>適合電競投注的人</h3>
        <ul>
          <li>本身就是電競遊戲玩家，對遊戲機制有深入了解</li>
          <li>長期追蹤特定賽區或戰隊，掌握第一手資訊</li>
          <li>習慣觀看直播，能即時判斷比賽走勢</li>
          <li>對數據分析有興趣，願意研究選手和隊伍統計</li>
        </ul>

        {/* ==================== 第 2 節 ==================== */}
        <h2 id="events">二、主流電競賽事介紹</h2>
        <p>
          以下是投注量最大、盤口最豐富的主流電競賽事：
        </p>

        <h3>英雄聯盟（League of Legends）</h3>
        <table>
          <thead>
            <tr><th>賽事</th><th>時間</th><th>說明</th></tr>
          </thead>
          <tbody>
            <tr><td>Worlds（世界大賽）</td><td>每年 9-11 月</td><td>最高殿堂，投注量最大的電競賽事</td></tr>
            <tr><td>MSI（季中邀請賽）</td><td>每年 5-6 月</td><td>各賽區冠軍參加，投注量次高</td></tr>
            <tr><td>LCK（韓國聯賽）</td><td>全年</td><td>最強賽區，盤口選項最豐富</td></tr>
            <tr><td>LPL（中國聯賽）</td><td>全年</td><td>隊伍多、比賽密集，投注機會最多</td></tr>
            <tr><td>LEC（歐洲聯賽）</td><td>全年</td><td>風格多變，時常出現冷門</td></tr>
          </tbody>
        </table>

        <h3>CS2（Counter-Strike 2）</h3>
        <table>
          <thead>
            <tr><th>賽事</th><th>時間</th><th>說明</th></tr>
          </thead>
          <tbody>
            <tr><td>Major</td><td>每年 2 次</td><td>CS2 最高級別賽事，類似足球世界盃</td></tr>
            <tr><td>IEM 系列賽</td><td>全年</td><td>ESL 主辦的高品質賽事</td></tr>
            <tr><td>BLAST 系列賽</td><td>全年</td><td>頂級隊伍的常規對抗賽</td></tr>
          </tbody>
        </table>

        <h3>Valorant</h3>
        <table>
          <thead>
            <tr><th>賽事</th><th>時間</th><th>說明</th></tr>
          </thead>
          <tbody>
            <tr><td>Champions</td><td>每年 8-9 月</td><td>年度總決賽，最高殿堂</td></tr>
            <tr><td>Masters</td><td>每年 2 次</td><td>賽季中的國際大賽</td></tr>
            <tr><td>各賽區聯賽</td><td>全年</td><td>Pacific、Americas、EMEA 三大賽區</td></tr>
          </tbody>
        </table>

        <InlineCTA />

        {/* ==================== 第 3 節 ==================== */}
        <h2 id="bet-types">三、電競投注類型</h2>
        <p>
          電競投注的類型比許多人想像的更豐富。除了基本的勝負盤外，還有許多遊戲特有的投注選項。
        </p>

        <h3>通用投注類型</h3>
        <ul>
          <li><strong>勝負盤（Match Winner）：</strong>預測哪支隊伍贏得系列賽（BO3 或 BO5）。最基本的投注方式</li>
          <li><strong>地圖數盤（Total Maps）：</strong>預測系列賽打幾張地圖。例如 BO3 的盤口是「大小 2.5 張地圖」——如果你認為會打滿三張（2:1 決勝），就投大</li>
          <li><strong>讓分盤（Map Handicap）：</strong>以地圖數計算讓分。例如強隊讓 1.5 張地圖，代表強隊需要 2:0 橫掃才算過盤</li>
          <li><strong>冠軍盤（Outright Winner）：</strong>預測整個賽事的冠軍隊伍，賠率高但等待時間長</li>
        </ul>

        <h3>LOL 特殊投注類型</h3>
        <ul>
          <li><strong>首殺（First Blood）：</strong>預測哪隊取得第一滴血</li>
          <li><strong>首條小龍：</strong>預測哪隊擊殺第一條小龍</li>
          <li><strong>首座防禦塔：</strong>預測哪隊推倒第一座塔</li>
          <li><strong>總擊殺數大小：</strong>預測單場比賽的總擊殺數</li>
          <li><strong>比賽時長大小：</strong>預測比賽是否超過某個時間（如 30 分鐘）</li>
        </ul>

        <h3>CS2 特殊投注類型</h3>
        <ul>
          <li><strong>單地圖勝負：</strong>預測特定地圖的勝負</li>
          <li><strong>回合數大小：</strong>預測地圖的總回合數（如大小 26.5 回合）</li>
          <li><strong>手槍局勝負：</strong>預測手槍局（第 1 和第 13 回合）的勝負</li>
          <li><strong>加時賽：</strong>預測比賽是否進入加時</li>
        </ul>

        <h3>投注類型選擇建議</h3>
        <table>
          <thead>
            <tr><th>投注類型</th><th>適合程度</th><th>建議</th></tr>
          </thead>
          <tbody>
            <tr><td>勝負盤</td><td>新手首選</td><td>最直觀，數據容易分析</td></tr>
            <tr><td>地圖數盤</td><td>進階新手</td><td>需要判斷系列賽的激烈程度</td></tr>
            <tr><td>首殺 / 首條龍</td><td>老手</td><td>需要深入了解隊伍的早期策略</td></tr>
            <tr><td>回合數 / 時長</td><td>老手</td><td>需要了解遊戲版本的節奏傾向</td></tr>
          </tbody>
        </table>

        {/* ==================== 第 4 節 ==================== */}
        <h2 id="lol">四、LOL 投注入門</h2>
        <p>
          英雄聯盟是全球投注量最大的電競項目。要做好 LOL 投注，你需要了解兩個核心分析維度：BP（Ban/Pick）和版本強勢。
        </p>

        <h3>BP 分析基礎</h3>
        <p>
          每場 LOL 比賽開始前的 Ban/Pick（英雄選擇）階段，是判斷比賽走勢的重要線索。以下是 BP 分析的基本框架：
        </p>
        <ol>
          <li><strong>識別版本 OP 英雄：</strong>每個版本都有幾個特別強勢的英雄。如果某隊搶到了版本最強的英雄，而對手沒有針對性的回應，這通常是利好信號</li>
          <li><strong>觀察選手的英雄池深度：</strong>部分選手的英雄池較淺——如果他的招牌英雄被 Ban 光，表現可能大幅下滑</li>
          <li><strong>陣容搭配的合理性：</strong>LOL 是團隊遊戲，單獨看英雄的強度不夠，還要看陣容之間的協同效應（如有沒有開團手段、有沒有足夠的控制技能）</li>
          <li><strong>對線強度判斷：</strong>根據雙方的線上英雄組合，判斷哪一方在前期對線階段有優勢</li>
        </ol>

        <h3>版本強勢分析</h3>
        <p>
          LOL 每兩週更新一次版本（Patch），大型賽事通常使用特定版本。版本更新可能帶來以下影響：
        </p>
        <ul>
          <li><strong>英雄強度洗牌：</strong>被加強的英雄可能從冷門變成必 Ban/Pick，改變 BP 生態</li>
          <li><strong>裝備和符文調整：</strong>影響各位置的強弱關係和出裝路線</li>
          <li><strong>地圖機制改變：</strong>如小龍、巴龍等中立資源的調整，影響團隊的決策優先級</li>
        </ul>
        <p>
          投注前，建議查看大賽使用的版本說明（Patch Notes），特別關注有哪些重大改動，以及哪些隊伍擅長的打法在新版本中是否仍然有效。
        </p>

        <h3>LOL 投注的關鍵數據</h3>
        <table>
          <thead>
            <tr><th>數據</th><th>說明</th><th>應用</th></tr>
          </thead>
          <tbody>
            <tr><td>藍 / 紅方勝率</td><td>LOL 的藍紅方有固有差異</td><td>藍方通常有 2-3% 的勝率優勢（先選英雄）</td></tr>
            <tr><td>前 15 分鐘金幣差</td><td>反映隊伍的早期對線能力</td><td>前期領先的隊伍最終勝率約 65-70%</td></tr>
            <tr><td>首條小龍控制率</td><td>反映隊伍對地圖資源的控制</td><td>高龍控率的隊伍通常有更穩定的比賽節奏</td></tr>
            <tr><td>平均比賽時長</td><td>反映隊伍的風格傾向</td><td>快攻隊伍 vs 後期隊伍的對決可用於判斷時長盤口</td></tr>
          </tbody>
        </table>

        <InlineCTA />

        {/* ==================== 第 5 節 ==================== */}
        <h2 id="cs2">五、CS2 投注入門</h2>
        <p>
          CS2（Counter-Strike 2）是 FPS 類電競投注的王者。與 LOL 不同，CS2 的核心分析圍繞在「地圖池」和「陣營勝率」兩個維度。
        </p>

        <h3>地圖池分析</h3>
        <p>
          CS2 的競技地圖池約有 7 張地圖，BO3 系列賽中雙方各 Ban 一張、各 Pick 一張，最後隨機選出第三張。每支隊伍在不同地圖上的表現可能差距極大——有的隊伍在 Mirage 勝率 80% 以上，但在 Nuke 可能低於 40%。
        </p>
        <ul>
          <li><strong>分析地圖 Ban/Pick：</strong>了解雙方的地圖偏好和弱點地圖，預判哪些地圖會被選中</li>
          <li><strong>單地圖投注機會：</strong>如果你判斷某隊在特定地圖上有壓倒性優勢，單地圖投注的價值可能高於系列賽投注</li>
          <li><strong>Decider 地圖分析：</strong>BO3 的第三張地圖（Decider）是隨機選出的，雙方可能都不擅長，增加了不確定性</li>
        </ul>

        <h3>陣營勝率（T 方 / CT 方）</h3>
        <p>
          CS2 的每張地圖都有 T 方（進攻方）和 CT 方（防守方）的固有平衡差異。部分地圖偏向 CT 方（如 Nuke），部分地圖較為平衡（如 Mirage）。分析陣營勝率有助於判斷比賽走勢和回合數盤口。
        </p>
        <table>
          <thead>
            <tr><th>地圖</th><th>CT 方傾向</th><th>T 方傾向</th><th>分析重點</th></tr>
          </thead>
          <tbody>
            <tr><td>Mirage</td><td>中等</td><td>中等</td><td>最平衡的地圖，個人技巧和配合度決定勝負</td></tr>
            <tr><td>Inferno</td><td>中等偏高</td><td>中等</td><td>Banana 和 Apps 控制是關鍵</td></tr>
            <tr><td>Nuke</td><td>高</td><td>低</td><td>CT 方優勢明顯，T 方需要極佳的戰術才能突破</td></tr>
            <tr><td>Anubis</td><td>中等偏高</td><td>中等</td><td>較新的地圖，各隊理解深度差異大</td></tr>
            <tr><td>Ancient</td><td>中等</td><td>中等偏高</td><td>T 方的執行力要求高，但成功率也高</td></tr>
            <tr><td>Dust2</td><td>中等</td><td>中等偏高</td><td>經典地圖，個人技巧和 AWP 對決影響大</td></tr>
            <tr><td>Vertigo</td><td>中等偏高</td><td>中等</td><td>地圖理解差異大，部分隊伍極強極弱</td></tr>
          </tbody>
        </table>

        <h3>CS2 投注關鍵數據</h3>
        <ul>
          <li><strong>各地圖勝率：</strong>各隊在每張地圖上的歷史勝率（建議看近 3 個月數據）</li>
          <li><strong>手槍局勝率：</strong>手槍局（第 1 和第 13 回合）的結果影響約 5-6 個回合的經濟走勢</li>
          <li><strong>選手 Rating：</strong>HLTV Rating 2.0 是衡量 CS2 選手個人表現的核心指標</li>
          <li><strong>多殺回合頻率：</strong>反映隊伍的火力穩定性和翻盤能力</li>
          <li><strong>線上賽 vs LAN 賽表現差異：</strong>部分選手在 LAN（現場賽）表現大幅下滑</li>
        </ul>

        <h3>CS2 投注數據來源</h3>
        <ul>
          <li><strong><a href="https://www.hltv.org" target="_blank" rel="noopener noreferrer" style={{ color: '#93c5fd' }}>HLTV.org</a>：</strong>CS2 最權威的數據和新聞網站，必看</li>
          <li><strong>Liquipedia：</strong>完整的賽事資訊和隊伍歷史</li>
          <li><strong>CSGOSTATS.gg：</strong>詳細的地圖和選手統計</li>
        </ul>

        {/* ==================== 第 6 節 ==================== */}
        <h2 id="risks">六、電競投注風險管理</h2>
        <p>
          電競投注除了與傳統運動投注共有的財務風險外，還有一些獨特的風險因素需要注意。
        </p>

        <h3>1. 假賽風險</h3>
        <p>
          假賽是電競投注面臨的最嚴重問題。近年雖然各大賽事主辦方和遊戲開發商加強了反假賽機制（如 Riot 的反假賽部門、Valve 的 VAC 系統），但問題仍未完全消除。降低假賽風險的方法：
        </p>
        <ul>
          <li><strong>只投注頂級賽事：</strong>Worlds、Major、Champions 等頂級賽事的假賽風險最低</li>
          <li><strong>避開線上資格賽：</strong>低階聯賽和線上資格賽的監管力度較弱，假賽風險較高</li>
          <li><strong>關注賠率異常波動：</strong>如果某場比賽的賠率在短時間內出現不合理的大幅變動，可能有內幕交易</li>
          <li><strong>避開不知名賽區：</strong>監管不成熟的賽區，選手收入低、假賽誘因高</li>
        </ul>

        <h3>2. 版本更新風險</h3>
        <p>
          電競遊戲的定期更新是一把雙面刃。版本更新可能讓你的分析模型瞬間失效，因為遊戲環境改變了。應對方法：
        </p>
        <ul>
          <li>大版本更新後的前幾天暫停投注，觀察新版本的影響</li>
          <li>關注各隊伍對新版本的適應速度</li>
          <li>了解哪些隊伍擅長快速適應新版本（通常是教練團較強的隊伍）</li>
        </ul>

        <h3>3. 選手狀態波動</h3>
        <p>
          電競選手的年齡普遍較輕（18-25 歲），心理素質和狀態穩定性不如傳統運動選手成熟。選手的個人問題（如與隊友衝突、心理健康、合約糾紛）可能對表現產生巨大影響。追蹤選手的社群動態和新聞，可以幫助你提前察覺潛在的風險。
        </p>

        <h3>4. 資金管理原則</h3>
        <p>
          電競投注的資金管理與傳統運動投注相同——設定總預算、單注上限（不超過總預算的 5%）、和停損機制。特別提醒：電競比賽的頻率很高（幾乎每天都有），很容易因為「隨時都能投注」而過度投注。建議每週設定投注場次上限。
        </p>

        {/* ========== FAQ ========== */}
        <h2 id="faq">FAQ 常見問題</h2>
        {faqList.map((item, i) => (
          <details key={i} style={{ marginBottom: 12, padding: '8px 12px', background: 'rgba(255,255,255,0.03)', borderRadius: 8 }}>
            <summary style={{ cursor: 'pointer', fontWeight: 600 }}>{item.question}</summary>
            <p style={{ marginTop: 8 }}>{item.answer}</p>
          </details>
        ))}

        {/* ========== 延伸閱讀 ========== */}
        <nav aria-label="延伸閱讀" style={{ marginTop: 40, padding: '16px 20px', background: 'rgba(212,175,55,0.06)', border: '1px solid rgba(212,175,55,0.15)', borderRadius: 12 }}>
          <p style={{ fontWeight: 700, color: '#D4AF37', marginBottom: 8 }}>延伸閱讀</p>
          <ul style={{ margin: 0, paddingLeft: 20, lineHeight: 2.2 }}>
            <li><Link to="/blog/sports-betting-guide">運彩完整指南</Link></li>
            <li><Link to="/blog/cpbl-betting-guide">中職運彩教學</Link></li>
            <li><Link to="/blog/world-cup-2026-guide">2026 世界盃投注指南</Link></li>
            <li>博弈新手完全指南</li>
          </ul>
        </nav>
      </article>
    </div>
  );
}
